import React from 'react'

import Link from '@Pure/Link'

export const form =
{
	model: 'PlaceTheme'.toLowerCase(),
	name: 'PlaceTheme'.toLowerCase(),

	form_title: 'Thème principal',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer ce thème',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce thème principal&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['placetheme[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau thème <strong> { model.label } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/themes-principaux/' + model.id }>
						Voir le thème
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'PlaceTheme'.toLowerCase(),
	title: 'Liste des thèmes principaux',
	link: '/configuration/themes-principaux',
	creation_link: '/configuration/nouveau-theme-principal',
	creation_label: 'Nouveau thème',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/themes-principaux/',
	searched_prop: 'label'
};

let config = Object.assign({ }, form);

Object.assign(config, list);

export default config